import { REDUCER_KEY_FIND_PREPARATIONS_SIMILARITY_SEARCH } from './constants';

export const findPreparationsSimilaritySearch = (state) => {
  return state.get(REDUCER_KEY_FIND_PREPARATIONS_SIMILARITY_SEARCH);
};

export const isSimilarityLoading = (state) => {
  return findPreparationsSimilaritySearch(state).isSimilarityLoading;
};

export const isResultsLoading = (state) => {
  return findPreparationsSimilaritySearch(state).isResultsLoading;
};

export const resultPayload = (state) => {
  return findPreparationsSimilaritySearch(state).resultPayload;
};

export const reactions = (state) => {
  return findPreparationsSimilaritySearch(state).reactions;
};

export const totalItems = (state) => {
  return findPreparationsSimilaritySearch(state).totalItems;
};

export const error = (state) => {
  return findPreparationsSimilaritySearch(state).error;
};

export const databaseId = (state) => {
  const result = resultPayload(state);
  return result && result.databaseId;
};
